import { Outlet, Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b bg-card shadow-sm">
        <div className="container mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/img/secondary-logo-with-text.svg"
                alt="Tickettrax Support Portal"
                className="h-12 w-auto"
              />
            </Link>
            <div className="flex items-center gap-3">
              <Link to="/track">
                <Button variant="outline" size="sm" className="gap-2">
                  <HelpCircle className="h-4 w-4" />
                  Track Ticket
                </Button>
              </Link>
              <Link to="/admin/login">
                <Button variant="ghost" size="sm">
                  Tech Team Login
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t bg-muted/30 py-6 mt-auto">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          <p>© 2026 Internal Ticketing System. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
